import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Mail, Phone, MapPin, Star, ShieldCheck } from 'lucide-react';
import { OmMark, FlowerMotif, GoldDivider } from './premium/Decor';

const Footer = () => {
  const { language } = useLanguage();
  const isHi = language === 'hi';

  return (
    <footer
      data-testid="footer"
      className="relative bg-brand-maroon-dark text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-mandala-watermark bg-repeat opacity-15 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <OmMark className="w-9 h-9 text-brand-gold-light" />
              <span className="font-playfair font-bold text-2xl text-brand-gold-light">
                Karma Kundali
              </span>
            </div>
            <p className={`text-white/70 text-sm leading-relaxed mb-4 ${isHi ? 'font-hindi' : 'font-outfit'}`}>
              {isHi
                ? 'वैदिक ज्योतिष की शक्ति से अपना भविष्य जानें — 15+ वर्षों का अनुभव, 10,000+ संतुष्ट ग्राहक।'
                : 'Discover your future with Vedic Astrology — 15+ years experience, 10,000+ happy clients.'}
            </p>
            <div className="flex items-center gap-1 text-brand-gold-light text-sm">
              {[1,2,3,4,5].map(i => <Star key={i} className="w-3.5 h-3.5 fill-current" />)}
              <span className="text-white/60 ml-2">4.9/5</span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className={`font-playfair font-bold text-lg text-brand-gold-light mb-4 ${isHi ? 'font-hindi-serif' : ''}`}>
              {isHi ? 'संपर्क' : 'Contact'}
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="mailto:karmakundali2@gmail.com" className="flex items-center gap-2 text-white/75 hover:text-brand-gold-light transition-colors">
                  <Mail className="w-4 h-4" /> karmakundali2@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/75">
                <MapPin className="w-4 h-4" /> {isHi ? 'भारत' : 'India'}
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className={`font-playfair font-bold text-lg text-brand-gold-light mb-4 ${isHi ? 'font-hindi-serif' : ''}`}>
              {isHi ? 'त्वरित लिंक' : 'Quick Links'}
            </h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="text-white/75 hover:text-brand-gold-light transition-colors">{isHi ? 'होम' : 'Home'}</a></li>
              <li><a href="/privacy-policy" className="text-white/75 hover:text-brand-gold-light transition-colors">{isHi ? 'गोपनीयता नीति' : 'Privacy Policy'}</a></li>
              <li><a href="/terms-conditions" className="text-white/75 hover:text-brand-gold-light transition-colors">{isHi ? 'नियम और शर्तें' : 'Terms & Conditions'}</a></li>
              <li><a href="/refund-policy" className="text-white/75 hover:text-brand-gold-light transition-colors">{isHi ? 'रिफंड पॉलिसी' : 'Refund Policy'}</a></li>
            </ul>
          </div>
        </div>

        <div className="text-brand-gold-light/60 mt-12">
          <GoldDivider className="!my-0" />
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-8 text-sm text-white/60">
          <p className={isHi ? 'font-hindi' : 'font-outfit'}>
            © 2026 Karma Kundali. {isHi ? 'सर्वाधिकार सुरक्षित।' : 'All rights reserved.'}
          </p>
          <p className={`flex items-center gap-1.5 ${isHi ? 'font-hindi' : 'font-outfit'}`}>
            <FlowerMotif className="w-4 h-4 text-brand-gold-light" />
            {isHi ? 'एस्ट्रो अविनाश द्वारा' : 'By Astro Avinash'}
          </p>
          <p className="flex items-center gap-1.5">
            <ShieldCheck className="w-4 h-4 text-green-400" />
            <span className={isHi ? 'font-hindi' : 'font-outfit'}>
              {isHi ? 'सुरक्षित भुगतान' : 'Secure Payment'}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
